import React from "react";
import { withAppLayout } from "../../../hoc";
import { ManagePayrollProvider } from "../../../contexts";
import PayrollCensusDetails from "../../../containers/Payroll/ErrorFoundInRecordsContainer/PayrollCensusDetails";

const PayrollCensusDetailsContainer = (props) => {
  return (
    <ManagePayrollProvider>
      <PayrollCensusDetails {...props} />
    </ManagePayrollProvider>
  );
};

export default withAppLayout(PayrollCensusDetailsContainer);
